var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isBool)?_c('div',{staticClass:"datapoint",class:{'is_set':_vm.data,'unset':!_vm.data}},[(_vm.data)?_c('span',[_vm._v("!")]):_vm._e()]):_c('div',{staticClass:"datapoint"},[_vm._v(" "+_vm._s(_vm.data)+" "+_vm._s(_vm.unit)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }